import React, { useState } from 'react';
import { Phone, Mail, MapPin, Instagram, Facebook } from 'lucide-react';
export function BookingContact() {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    petName: '',
    serviceType: '',
    locationType: '',
    message: '',
    consentAlerts: false,
    consentMarketing: false
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle form submission logic here
    console.log('Form submitted:', formData);
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const {
      name,
      value,
      type
    } = e.target;
    const checked = (e.target as HTMLInputElement).checked;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };
  return <section id="contact" className="py-24 bg-brand-charcoal text-brand-light relative" data-id="element-17">
      {/* Texture Overlay */}
      <div className="absolute inset-0 opacity-5 pointer-events-none" style={{
      backgroundImage: 'radial-gradient(#E8700A 1px, transparent 1px)',
      backgroundSize: '20px 20px'
    }} data-id="element-18"></div>

      <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-19">
        <div className="text-center mb-16" data-id="element-20">
          <h2 className="text-4xl md:text-5xl font-heading mb-4" data-id="element-21">
            Ready to Book Your Pet's Next Groom?
          </h2>
          <p className="text-lg text-brand-light/70" data-id="element-22">
            Mobile or salon, we're ready for you. Reach out today.
          </p>
        </div>

        <div className="flex flex-col lg:flex-row gap-16 max-w-6xl mx-auto" data-id="element-23">
          {/* Contact Info Left */}
          <div className="w-full lg:w-1/3 space-y-10" data-id="element-24">
            <div data-id="element-25">
              <h3 className="text-2xl font-heading mb-6 text-brand-orange" data-id="element-26">
                Contact Info
              </h3>
              <ul className="space-y-6" data-id="element-27">
                <li className="flex items-start gap-4" data-id="element-28">
                  <Phone className="text-brand-pink mt-1" size={24} data-id="element-29" />
                  <div data-id="element-30">
                    <p className="font-semibold text-lg" data-id="element-31">(602) 888-2209</p>
                    <p className="text-sm text-brand-light/60" data-id="element-32">Call or Text</p>
                  </div>
                </li>
                <li className="flex items-start gap-4" data-id="element-33">
                  <Mail className="text-brand-pink mt-1" size={24} data-id="element-34" />
                  <div data-id="element-35">
                    <p className="font-semibold text-lg" data-id="element-36">
                      info@thevalleygrooming.com
                    </p>
                  </div>
                </li>
                <li className="flex items-start gap-4" data-id="element-37">
                  <MapPin className="text-brand-pink mt-1" size={24} data-id="element-38" />
                  <div data-id="element-39">
                    <p className="font-semibold text-lg" data-id="element-40">Goodyear, AZ</p>
                    <p className="text-sm text-brand-light/60" data-id="element-41">
                      Salon Location
                    </p>
                  </div>
                </li>
              </ul>
            </div>

            <div data-id="element-42">
              <h3 className="text-2xl font-heading mb-6 text-brand-orange" data-id="element-43">
                Hours
              </h3>
              <ul className="space-y-2 text-brand-light/80" data-id="element-44">
                <li className="flex justify-between" data-id="element-45">
                  <span data-id="element-46">Mon–Fri:</span> <span data-id="element-47">8am–6pm</span>
                </li>
                <li className="flex justify-between" data-id="element-48">
                  <span data-id="element-49">Sat:</span> <span data-id="element-50">8am–6pm</span>
                </li>
                <li className="flex justify-between text-brand-pink" data-id="element-51">
                  <span data-id="element-52">Sun:</span> <span data-id="element-53">Closed</span>
                </li>
              </ul>
            </div>

            <div className="flex gap-4 pt-4" data-id="element-54">
              <a href="#" className="w-12 h-12 bg-brand-dark rounded-full flex items-center justify-center hover:bg-brand-orange transition-colors" data-id="element-55">
                <Instagram size={24} data-id="element-56" />
              </a>
              <a href="#" className="w-12 h-12 bg-brand-dark rounded-full flex items-center justify-center hover:bg-brand-orange transition-colors" data-id="element-57">
                <Facebook size={24} data-id="element-58" />
              </a>
            </div>
          </div>

          {/* Form Right */}
          <div id="book" className="w-full lg:w-2/3 bg-brand-dark p-8 md:p-10 rounded-3xl border border-brand-light/10 shadow-2xl" data-id="element-59">
            <form onSubmit={handleSubmit} className="space-y-6" data-id="element-60">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-61">
                <div data-id="element-62">
                  <label className="block text-sm font-medium text-brand-light/80 mb-2" data-id="element-63">
                    Your Name
                  </label>
                  <input type="text" name="name" required className="w-full bg-brand-charcoal border border-brand-light/20 rounded-xl px-4 py-3 text-brand-light focus:outline-none focus:border-brand-orange focus:ring-1 focus:ring-brand-orange transition-colors min-h-[44px]" data-id="element-64" />
                </div>
                <div data-id="element-65">
                  <label className="block text-sm font-medium text-brand-light/80 mb-2" data-id="element-66">
                    Phone Number
                  </label>
                  <input type="tel" name="phone" required className="w-full bg-brand-charcoal border border-brand-light/20 rounded-xl px-4 py-3 text-brand-light focus:outline-none focus:border-brand-orange focus:ring-1 focus:ring-brand-orange transition-colors min-h-[44px]" data-id="element-67" />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-68">
                <div data-id="element-69">
                  <label className="block text-sm font-medium text-brand-light/80 mb-2" data-id="element-70">
                    Email Address
                  </label>
                  <input type="email" name="email" required className="w-full bg-brand-charcoal border border-brand-light/20 rounded-xl px-4 py-3 text-brand-light focus:outline-none focus:border-brand-orange focus:ring-1 focus:ring-brand-orange transition-colors min-h-[44px]" data-id="element-71" />
                </div>
                <div data-id="element-72">
                  <label className="block text-sm font-medium text-brand-light/80 mb-2" data-id="element-73">
                    Pet's Name & Breed
                  </label>
                  <input type="text" name="petName" required className="w-full bg-brand-charcoal border border-brand-light/20 rounded-xl px-4 py-3 text-brand-light focus:outline-none focus:border-brand-orange focus:ring-1 focus:ring-brand-orange transition-colors min-h-[44px]" data-id="element-74" />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-75">
                <div data-id="element-76">
                  <label className="block text-sm font-medium text-brand-light/80 mb-2" data-id="element-77">
                    Service Type
                  </label>
                  <select name="serviceType" required className="w-full bg-brand-charcoal border border-brand-light/20 rounded-xl px-4 py-3 text-brand-light focus:outline-none focus:border-brand-orange focus:ring-1 focus:ring-brand-orange transition-colors min-h-[44px] appearance-none" data-id="element-78">
                    <option value="" data-id="element-79">Select a service...</option>
                    <option value="full" data-id="element-80">Full Grooming & Haircut</option>
                    <option value="bath" data-id="element-81">Bath & Brush</option>
                    <option value="puppy" data-id="element-82">Puppy Trim</option>
                    <option value="other" data-id="element-83">Other</option>
                  </select>
                </div>
                <div data-id="element-84">
                  <label className="block text-sm font-medium text-brand-light/80 mb-2" data-id="element-85">
                    Location Preference
                  </label>
                  <div className="flex gap-4 h-[44px] items-center" data-id="element-86">
                    <label className="flex items-center gap-2 cursor-pointer" data-id="element-87">
                      <input type="radio" name="locationType" value="mobile" className="w-4 h-4 text-brand-orange bg-brand-charcoal border-brand-light/20 focus:ring-brand-orange focus:ring-offset-brand-dark" data-id="element-88" />
                      <span data-id="element-89">Mobile</span>
                    </label>
                    <label className="flex items-center gap-2 cursor-pointer" data-id="element-90">
                      <input type="radio" name="locationType" value="salon" className="w-4 h-4 text-brand-orange bg-brand-charcoal border-brand-light/20 focus:ring-brand-orange focus:ring-offset-brand-dark" data-id="element-91" />
                      <span data-id="element-92">Salon</span>
                    </label>
                  </div>
                </div>
              </div>

              <div data-id="element-93">
                <label className="block text-sm font-medium text-brand-light/80 mb-2" data-id="element-94">
                  Message (Optional)
                </label>
                <textarea name="message" rows={3} className="w-full bg-brand-charcoal border border-brand-light/20 rounded-xl px-4 py-3 text-brand-light focus:outline-none focus:border-brand-orange focus:ring-1 focus:ring-brand-orange transition-colors resize-none" data-id="element-95"></textarea>
              </div>

              <div className="space-y-4 pt-2" data-id="element-96">
                <label className="flex items-start gap-3 cursor-pointer group" data-id="element-97">
                  <div className="flex-shrink-0 mt-1" data-id="element-98">
                    <input type="checkbox" name="consentAlerts" required className="w-5 h-5 rounded border-brand-light/20 text-brand-orange focus:ring-brand-orange focus:ring-offset-brand-dark bg-brand-charcoal" data-id="element-99" />
                  </div>
                  <span className="text-xs text-brand-light/60 group-hover:text-brand-light/80 transition-colors leading-relaxed" data-id="element-100">
                    I consent to receive SMS Notifications and Alerts from The
                    Valley Mobile Grooming. Message frequency varies. Message &
                    data rates may apply. Text HELP to (520) 650-5224 or STOP to
                    unsubscribe.
                  </span>
                </label>

                <label className="flex items-start gap-3 cursor-pointer group" data-id="element-101">
                  <div className="flex-shrink-0 mt-1" data-id="element-102">
                    <input type="checkbox" name="consentMarketing" className="w-5 h-5 rounded border-brand-light/20 text-brand-orange focus:ring-brand-orange focus:ring-offset-brand-dark bg-brand-charcoal" data-id="element-103" />
                  </div>
                  <span className="text-xs text-brand-light/60 group-hover:text-brand-light/80 transition-colors leading-relaxed" data-id="element-104">
                    I agree to receive occasional marketing messages from The
                    Valley Mobile Grooming. Message & data rates may apply. Text
                    HELP to (520) 650-5224 or STOP to unsubscribe.
                  </span>
                </label>
              </div>

              <button type="submit" className="w-full bg-brand-orange text-brand-light py-4 rounded-xl font-semibold text-lg hover:bg-orange-600 hover:box-glow transition-all duration-300 mt-4 min-h-[48px]" data-id="element-105">
                Submit Request
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>;
}